import BotImage from '../assets/bot.png';
import ProfileImage from '../assets/profile.png';

export const getProfileImageSrc = (profilePicture?: string, username?: string): string => {
  // Check if it's a bot
  if (username && (username.toLowerCase() === 'house' || username.toLowerCase() === 'bot')) {
    return BotImage;
  }
  
  // Use the profile picture from the game data
  if (profilePicture && profilePicture.trim() !== '') {
    if (profilePicture.startsWith('http')) {
      return profilePicture;
    }
    return `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/uploads/profile-pictures/${profilePicture}`;
  }
  
  // Default fallback
  return ProfileImage;
};